import clsx from "clsx";
import React from "react";
import ImageResizer from "components/ImageResizer";
import { Organisation } from "features/Organisation/OrganisationStore";

function OrganisationLogo({
  organisation,
  className,
}: {
  organisation?: Organisation;
  className?: string;
}) {
  if (!organisation) return null;
  return (
    <div
      className={clsx(
        "text-white w-6 h-6 text-sm flex justify-center items-center rounded overflow-hidden",
        { "bg-indigo-700": !organisation?.logo },
        className
      )}
    >
      {organisation?.logo ? (
        <ImageResizer
          src={organisation.logo ?? ""}
          alt={organisation.name}
          className="!object-cover w-auto h-auto aspect-1"
        />
      ) : (
        `${organisation.name?.substring(0, 1).toUpperCase()}`
      )}
    </div>
  );
}

export default React.memo(OrganisationLogo);
